import {directionIndicator, DirectionIndicator} from "./direction-indicator/DirectionIndicatorComponent";
import {modalClose, ModalClose} from "./modal-close/ModalCloseComponent";
import {ivSidebarComponent, IvSidebarComponent} from "./iv-sidebar/IvSidebarComponent";
import {IvSidebarService} from "./iv-sidebar/service/IvSidebarService";
import {demoAccountIndicator, DemoAccountIndicator} from "./demo-account-indicator/DemoAccountIndicatorComponent";
import {utilisationBar, UtilisationBar} from "./utilisation/UtilisationBar";
import {DirectionChangeIndicator, directionChangeIndicator} from "./change-indicator/DirectionChangeIndicator";
import {sidebarAlertsComponent, SidebarAlertsComponent} from "./iv-sidebar/views/alerts/SidebarAlertsComponent";

import Ghost from "./ghost";
import {sortIndicator, SortIndicator} from "./sort-indicator/SortIndicatorComponent";
import {directionChangeIndicatorV2, DirectionChangeIndicatorV2} from "./change-indicator-v2/DirectionChangeIndicatorV2";

export default angular.module("tfApp.components.ui", [Ghost()])
                      .component(DirectionIndicator, directionIndicator())
                      .component(IvSidebarComponent, ivSidebarComponent())
                      .component(DemoAccountIndicator, demoAccountIndicator())
                      .directive(ModalClose, modalClose)
                      .service(IvSidebarService.id, IvSidebarService)
                      .component(UtilisationBar, utilisationBar())
                      .component(DirectionChangeIndicator, directionChangeIndicator())
                      .component(DirectionChangeIndicatorV2, directionChangeIndicatorV2())
                      .component(SidebarAlertsComponent, sidebarAlertsComponent())
                      .component(SortIndicator, sortIndicator())
                      .name;
